import React, { Component, Fragment } from 'react';
import { Col, ListGroup, ListGroupItem, Row } from 'react-bootstrap';
import { connect } from "react-redux";

class EducationRequirements extends Component {
    processRequirement(requirement) {
        const { colleges } = this.props.educationInfo;
        let status = false;
        for (let college of colleges) {
            for (let course of college.courses) {
                if (course.requirement === requirement || course.requirement.includes(requirement)) {
                    if (EducationRequirements.calculateGradePointsForGrade(course.grade) < 2.0)
                        continue;
                    status = true;
                }
            }
        }
        return {
            status
        };
    }

    static calculateGradePointsForGrade(grade) {
        let courseGradePoints;
        if (!grade) return 0.0;
        switch (grade.charAt(0)) {
            case "A":
                courseGradePoints = 4.0;
                break;
            case "B":
                courseGradePoints = 3.0;
                break;
            case "C":
                courseGradePoints = 2.0;
                break;
            case "D":
                courseGradePoints = 1.0;
                break;
            default:
                courseGradePoints = 0.0;
        }
        if (grade.length === 2)
            switch (grade.charAt(1)) {
                case "-":
                    courseGradePoints = courseGradePoints - 0.3;
                    break;
                case "+":
                    courseGradePoints = courseGradePoints + 0.3;
                    break;
                default:
                    break;
            }
        return courseGradePoints;
    }

    processGPA() {
        const { colleges } = this.props.educationInfo;
        let gradePoints = 0.0;
        let units = 0.0;
        for (let college of colleges) {
            for (let course of college.courses) {
                if (course.units &&
                    course.units !== "" &&
                    course.grade &&
                    course.grade !== "" &&
                    course.grade !== "EW" && // Forgive EW
                    college.unitType &&
                    college.unitType !== "") {
                    let courseUnits = college.unitType === 'S' ? parseFloat(course.units) : 0.6667 * course.units;
                    let courseGradePoints = EducationRequirements.calculateGradePointsForGrade(course.grade);
                    gradePoints += courseGradePoints * courseUnits;
                    units += courseUnits;
                }
            }
        }

        const gpa = units > 0 ? gradePoints / units : 0.0;
        return {
            gpa,
            style: gpa > 2.499 ? 'success' : gpa === 0.0 ? 'warning' : 'danger'
        }
    }

  render() {
    const anatomyStatus = this.processRequirement('anatomy');
    const humanDevStatus = this.processRequirement('humanDev');
    const medTerminologyStatus = this.processRequirement('medTerminology');
    const psychologyStatus = this.processRequirement('psychology');
    const GPAStatus = this.processGPA();

    return (
      <Fragment>
        <Row>
          <Col md={3}>
            <ListGroup>
              <ListGroupItem bsStyle={anatomyStatus.status ? 'success' : 'danger'} header="Human Anatomy"/>
            </ListGroup>
          </Col>
          <Col md={3}>
            <ListGroup>
              <ListGroupItem bsStyle={humanDevStatus.status ? 'success' : 'danger'} header="Human Development" />
            </ListGroup>
          </Col>
          <Col md={3}>
            <ListGroup>
              <ListGroupItem bsStyle={medTerminologyStatus.status ? 'success' : 'danger'} header="Medical Terminology"/>

            </ListGroup>
          </Col>
          <Col md={3}>
            <ListGroup>
              <ListGroupItem bsStyle={psychologyStatus.status ? 'success' : 'danger'} header="Introduction to Psychology"/>
            </ListGroup>
          </Col>
        </Row>
        <Row>
          <Col md={12}>
            <ListGroup>
              <ListGroupItem bsStyle={GPAStatus.style}>
                Prerequisite GPA: {GPAStatus.gpa.toPrecision(4)}
              </ListGroupItem>
            </ListGroup>
          </Col>
        </Row>
      </Fragment>
    );
  };
}

export default connect(
    (state) => {
        const { educationInfo } = state;
        return {
            educationInfo
        };
    }
)(EducationRequirements);